import { TableCell } from "@mui/material";
import { useEffect, useState } from "react";
import ReportTable from "../../external/ensolvers-core-frontend-mui/components/ReportTable";
import { ReportHeader } from "../../external/ensolvers-core-frontend-mui/dto/ReportDTO";
import { useOverStaffAssignationDetails } from "../../hooks/useOverStaffReport";
import OverStaffAssignation from "../../models/OverStaffReport/OverStaffAssignation";
import OpsDateUtils from "../../utils/OpsDateUtils";
import { AppDialog } from "../AppDialog";

interface Props {
  userName: string;
  userExternalId: string;
  setUserExternalId: (externalId: string | undefined) => void;
}

export const OverStaffAssignationDetails = ({ userName, userExternalId, setUserExternalId }: Props) => {
  const [headers, setHeaders] = useState<ReportHeader[]>([]);
  const [active, setActive] = useState<boolean>(false);
  const { rows, isLoading } = useOverStaffAssignationDetails(userExternalId);

  useEffect(() => {
    loadHeaders();
  }, [userExternalId]);

  const loadHeaders = () => {
    setHeaders(
      new Array<ReportHeader>(
        { label: "Project", align: "center" },
        { label: "Role", align: "center" },
        { label: "Start date", align: "center" },
        { label: "End date", align: "center" },
        { label: "External hours", align: "center" },
        { label: "Bonus", align: "center" },
        { label: "Shadow", align: "center" },
      ),
    );
  };

  const results = rows.filter((row) => {
    return !row.endDate || new Date(row.endDate).getTime() > new Date().getTime();
  });

  const getContent = () => {
    return (
      <>
        <ReportTable<OverStaffAssignation>
          headers={headers!}
          rows={active ? results : rows}
          denseTable
          tableRow={(instance) => (
            <>
              <TableCell>{instance.projectName}</TableCell>
              <TableCell>{instance.assignationRole}</TableCell>
              <TableCell>{OpsDateUtils.formatUTCAsDDMMMYYY(instance.startDate)}</TableCell>
              <TableCell>{!!instance.endDate ? OpsDateUtils.formatUTCAsDDMMMYYY(instance.endDate) : ""}</TableCell>
              <TableCell align="center">{instance.externalHours}</TableCell>
              <TableCell align="center">{!!instance.bonus && `${instance.bonus}%`}</TableCell>
              <TableCell align="center">{instance.shadow ? "Yes" : "No"}</TableCell>
            </>
          )}
        />
      </>
    );
  };

  return (
    <>
      {/* Dialog to display user assignation details */}
      <AppDialog
        maxWidth="xl"
        open={!!userExternalId}
        onClose={() => setUserExternalId(undefined)}
        title={`User name: ${userName}`}
        content={getContent()}
        hideCancel
        isLoading={isLoading}
        toggle
        setActive={setActive}
        active={active}
      />
    </>
  );
};
